import _ from 'lodash';
import createCachedSelector from 're-reselect';
import { getPredictor } from '../getPredictor';

export const getFunctions = createCachedSelector(
  [getPredictor],
  predictor => _.chain(predictor).get('functionMappings').map('function').value()
)(
  (state, chartType) => chartType
);